import { Outlet, createFileRoute } from "@tanstack/react-router";

/** Layout for a project. The project overview lives in the index route
 * (`…p.$projectSlug.index.tsx`); the work-package detail renders here via Outlet. */
export const Route = createFileRoute("/_app/plan/p/$projectSlug")({
  component: () => <Outlet />,
});
